<script context="module" lang="ts">
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';
	import { onMount } from 'svelte';

	export const config: SectionConfig = {
		collection: 'section_anchor',
		availableFor: ['pages', 'special-pages'],
		query: gql`
      anchor
    `
	};

	// optional: define a type for the props (note: injectTranslations is applied)
	type Props = {
		anchor: string;
	};
</script>

<script lang="ts">
	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)

	onMount(() => {
		setTimeout(() => {
			if (location.hash === `#${data.anchor}`) {
				const anchorElement = document.getElementById(data.anchor);
				if (anchorElement) {
					anchorElement.scrollIntoView({ behavior: 'smooth' });
				}
			}
		}, 100);
	});
</script>

<div class="anchor-wrap">
	<div class="anchor" id={data.anchor} />
</div>

<style lang="scss">
	.anchor-wrap {
		position: relative;
		width: 0;
		height: 0;

		.anchor {
			position: absolute;
			top: -64px; /* Offset for header */
		}
	}
	:global(html) {
		scroll-behavior: smooth;
	}
</style>
